import { useBreakpoints, useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Avatar, Location, Text } from '../../forms'
import { Box } from '../../widgets'
import { CardDetails } from '../payment'
import { randomInt } from '@10000/common'

export const Company = ({ active, fromFreeSquiz }) => {
  const request = useRequest('tenant')
  const { company: { name = '', country, city = '', avatar = randomInt(6) } } = useView('tenant')
  const { push } = useStack()
  const { mobile } = useBreakpoints()

  useShell({ active, mode: 'progress narrow', step: fromFreeSquiz ? 2 : 5, max: fromFreeSquiz ? 4 : 6 })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(true, mobile) }))

  const handleCompanyDetails = (details) => request('companyUpdated', details)
    .then(() => push(CardDetails, { props: { fromFreeSquiz } }))

  return <InputScreen
    onSubmit={handleCompanyDetails}
    title="Set up your company"
    footerButton="Next"
    fade
    formValues={{ avatar, name, country, city }}
  >
    <Box justifyContent="center" alignItems="center" column gap={mobile ? 16 : 24} pt={2}>
      <Avatar
        name="avatar"
        size={mobile ? 'medium' : 'large'}
        mode="company"
      />
      <Text name="name" title="Company name" required/>
      <Location country={country} />
    </Box>
  </InputScreen>
}